import { Loader2, Trophy, CheckCircle2 } from 'lucide-react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { useUserQuizAttempts } from '@/services/admin/users.service'

interface UserQuizAttemptsProps {
  userId: string
}

export function UserQuizAttempts({ userId }: UserQuizAttemptsProps) {
  const { data: attempts, isLoading } = useUserQuizAttempts(userId)

  const formatDate = (dateString: string) =>
    new Date(dateString).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    )
  }

  if (!attempts || attempts.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>Nenhum quiz respondido</p>
      </div>
    )
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Quiz</TableHead>
          <TableHead>Episódio</TableHead>
          <TableHead>Módulo</TableHead>
          <TableHead>Pontuação</TableHead>
          <TableHead>Data</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {attempts.map((attempt) => (
          <TableRow key={attempt.quizId}>
            <TableCell className="font-medium">{attempt.quizTitle}</TableCell>
            <TableCell className="text-muted-foreground">{attempt.episodeTitle}</TableCell>
            <TableCell className="text-muted-foreground">{attempt.moduleTitle}</TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                {attempt.score >= 70 ? (
                  <Badge variant="default" className="gap-1">
                    <CheckCircle2 className="h-3 w-3" />
                    {attempt.score}%
                  </Badge>
                ) : (
                  <Badge variant="secondary" className="gap-1">
                    <Trophy className="h-3 w-3" />
                    {attempt.score}%
                  </Badge>
                )}
                <span className="text-xs text-muted-foreground">
                  {attempt.correctAnswers}/{attempt.totalQuestions}
                </span>
              </div>
            </TableCell>
            <TableCell className="text-sm">{formatDate(attempt.completedAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
